import { gql } from 'apollo-angular';

export const modulePageGraphs = gql`
	fragment ModulePageGraphs on ModuleGraphOutput {
		id
		type
		colors
		formula
		moduleId
		updateTimestamp
		localizations {
			title
			labels
			locale
			legends
			descriptions
		}
	}
`;
